import Swal from 'sweetalert2/dist/sweetalert2.js'
import { $, $$ } from '@/utilities/helpers';
import Choices from 'choices.js'

import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import ImageEditor from '@uppy/image-editor';
import ThumbnailGenerator from '@uppy/thumbnail-generator';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/image-editor/dist/style.min.css';

let AUSTRALIAN_STATES_AND_TERRITORIES = [
    { name: 'Australian Capital Territory' },
    { name: 'New South Wales' },
    { name: 'Northern Territory' },
    { name: 'Queensland' },
    { name: 'South Australia' },
    { name: 'Tasmania' },
    { name: 'Victoria' },
    { name: 'Western Australia' },
];

let CANADIAN_PROVINCES_AND_TERRITORIES = [
    { name: 'Alberta' },
    { name: 'British Columbia' },
    { name: 'Manitoba' },
    { name: 'New Brunswick' },
    { name: 'Newfoundland and Labrador' },
    { name: 'Northwest Territories' },
    { name: 'Nova Scotia' },
    { name: 'Nunavut' },
    { name: 'Ontario' },
    { name: 'Prince Edward Island' },
    { name: 'Quebec' },
    { name: 'Saskatchewan' },
    { name: 'Yukon' },
];

let US_STATES = [
    { name: 'Alabama' },
    { name: 'Alaska' },
    { name: 'Arizona' },
    { name: 'Arkansas' },
    { name: 'California' },
    { name: 'Colorado' },
    { name: 'Connecticut' },
    { name: 'Delaware' },
    { name: 'Florida' },
    { name: 'Georgia' },
    { name: 'Hawaii' },
    { name: 'Idaho' },
    { name: 'Illinois' },
    { name: 'Indiana' },
    { name: 'Iowa' },
    { name: 'Kansas' },
    { name: 'Kentucky' },
    { name: 'Louisiana' },
    { name: 'Maine' },
    { name: 'Maryland' },
    { name: 'Massachusetts' },
    { name: 'Michigan' },
    { name: 'Minnesota' },
    { name: 'Mississippi' },
    { name: 'Missouri' },
    { name: 'Montana' },
    { name: 'Nebraska' },
    { name: 'Nevada' },
    { name: 'New Hampshire' },
    { name: 'New Jersey' },
    { name: 'New Mexico' },
    { name: 'New York' },
    { name: 'North Carolina' },
    { name: 'North Dakota' },
    { name: 'Ohio' },
    { name: 'Oklahoma' },
    { name: 'Oregon' },
    { name: 'Pennsylvania' },
    { name: 'Rhode Island' },
    { name: 'South Carolina' },
    { name: 'South Dakota' },
    { name: 'Tennessee' },
    { name: 'Texas' },
    { name: 'Utah' },
    { name: 'Vermont' },
    { name: 'Virginia' },
    { name: 'Washington' },
    { name: 'West Virginia' },
    { name: 'Wisconsin' },
    { name: 'Wyoming' },
];

let $country = $('[name="Country"]');
let $state = $('[name="State"]');

const updateStateOptions = (country = '', state = '') => {

    if (window.state_select) window.state_select.destroy();

    const countries = {
        'Australia': AUSTRALIAN_STATES_AND_TERRITORIES,
        'Canada': CANADIAN_PROVINCES_AND_TERRITORIES,
        'United States': US_STATES
    };

    // Reset and show/hide state field
    $state.innerHTML = '';
    const stateField = $state.closest('.field');

    if (!countries[country]) {
        stateField.style.display = 'none';
        return;
    }

    stateField.style.display = 'block';

    // Populate options
    countries[country].forEach(stateObj => {
        const option = document.createElement('option');
        option.value = stateObj.name;
        option.text = stateObj.name;
        $state.appendChild(option);
    });


    window.state_select = new Choices($('[name="State"]'), {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: false,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select a state',
    });

    if (state) window.state_select.setChoiceByValue(state);
};

if ($country) {

    $country.addEventListener('change', (e) => {
        let country = e.target.value;
        updateStateOptions(country);
    });

    updateStateOptions($country.value, $state.value);

}

let $position = $('.js-position');
let $subPosition = $('.js-subposition');
let $professionalRegistrationBody = $('.js-professional-registration-body');
let $professionalRegistrationNumber = $('.js-professional-registration-number');
let $affiliatedOrganisation = $('.js-affiliated-organisation');
let $educationInstitute = $('.js-education-institute');
let $studentNumber = $('.js-student-number');

if ($position) {

    let $positionSelect = $position.querySelector('select');
    let $positionInput = $position.querySelector('[name="Position"]');

    $positionSelect.value = $positionInput.value;
    $positionSelect.dispatchEvent(new Event('change'));

    window.positionChoice = new Choices($positionSelect, {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: false,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select a position',
    });

    positionChoice.setChoiceByValue($positionInput.value);

    positionChoice.passedElement.element.addEventListener('change', (e) => {
        $positionInput.style.display = 'none';
        $positionInput.value = e.detail.value;
        $position.querySelector('.choices').style.display = 'block';
    });

}

const updateSubPositionOptions = (position = '', selectedSubPosition = '') => {

    // // Reset and show/hide state field
    const subPositionField = $subPosition.closest('.field');
    const $subPositionSelect = $subPosition.querySelector('select');
    $subPositionSelect.innerHTML = '';


    if (!window.positions[position]) {
        subPositionField.style.opacity = '0';
        return;
    }

    // Update the visibility of the alternative fields
    if (position === 'Student') {

        $educationInstitute.style.display = 'block';
        $studentNumber.style.display = 'block';
        $professionalRegistrationBody.style.display = 'none';
        $professionalRegistrationNumber.style.display = 'none';
        $affiliatedOrganisation.style.display = 'none';

        $professionalRegistrationBody.querySelector('input').value = '';
        $professionalRegistrationNumber.querySelector('input').value = '';
        $affiliatedOrganisation.querySelector('input').value = '';


    } else if (position === 'Other') {

        $educationInstitute.style.display = 'none';
        $studentNumber.style.display = 'none';
        $professionalRegistrationBody.style.display = 'block';
        $professionalRegistrationNumber.style.display = 'block';
        $affiliatedOrganisation.style.display = 'block';

        $educationInstitute.querySelector('input').value = '';
        $studentNumber.querySelector('input').value = '';
        $professionalRegistrationBody.querySelector('input').value = '';
        $professionalRegistrationNumber.querySelector('input').value = '';

    } else {

        $professionalRegistrationBody.style.display = 'block';
        $professionalRegistrationNumber.style.display = 'block';
        $affiliatedOrganisation.style.display = 'none';
        $educationInstitute.style.display = 'none';
        $studentNumber.style.display = 'none';

        $affiliatedOrganisation.querySelector('input').value = '';
        $educationInstitute.querySelector('input').value = '';
        $studentNumber.querySelector('input').value = '';


    }

    subPositionField.style.opacity = '1';

    // Populate options
    window.positions[position].forEach(position_item => {
        const option = document.createElement('option');
        option.value = position_item
        option.text = position_item;
        if (position_item === selectedSubPosition) option.selected = true;
        $subPositionSelect.appendChild(option);
    });

    if (window.subpositionChoice) window.subpositionChoice.destroy();



    window.subpositionChoice = new Choices($subPositionSelect, {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: true,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select a sub position',
    });

    window.subpositionChoice.setChoiceByValue(selectedSubPosition);
};

if ($position) {

    $position.addEventListener('change', (e) => {
        let position = e.target.value;
        updateSubPositionOptions(position);
    });

    updateSubPositionOptions($position.querySelector('select').value, $subPosition.querySelector('select').value);

}

if ($('.js-institution')) {
    let $institution = $('.js-institution');
    let $institutionSelect = $institution.querySelector('select');
    let $institutionInput = $institution.querySelector('[name="Institution"]');

    $institutionSelect.value = $institutionInput.value;
    $institutionSelect.dispatchEvent(new Event('change'));


    let institutionChoice = new Choices($institutionSelect, {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: false,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select an institution',
    });

    institutionChoice.setChoiceByValue($institutionInput.value);


    institutionChoice.passedElement.element.addEventListener('change', (e) => {
        $institutionInput.style.display = 'none';
        $institutionInput.value = e.detail.value;
        $('.js-institution').querySelector('.choices').style.display = 'block';
    });



}



if ($('[name="Country"]')) {
    window.country_select = new Choices($('[name="Country"]'), {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: false,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select a country',
    });
}

if ($('[name="State"]')) {
    window.state_select = new Choices($('[name="State"]'), {
        searchEnabled: true,
        searchChoices: true,
        searchResultLimit: 5,
        shouldSort: false,
        itemSelectText: '',
        placeholder: true,
        placeholderValue: 'Select a state',
    });
}


let $logoutButtons = $$('.js-logout');

const SIMULATED_DELAY = 789;

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})


if ($logoutButtons) {
    $logoutButtons.forEach($logout => {
        $logout.addEventListener('click', (e) => {
            e.preventDefault();
            Swal.fire({
                title: 'Logout',
                text: 'Are you sure you want to log out of your account?',
                icon: 'info',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Log out'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = $logout.href;
                }
            })
        });


    });
}


/**
 * 
 * Handle a form response
 * 
 * @param {object} response 
 */
const handleFormResponse = (response) => {
    console.log(response);

    const avatarUrl = response?.data?.Avatar?.trim();
    const avatarElement = document.querySelector('.flyout__header__avatar');

    if (avatarElement && avatarUrl) {
        console.log(`<img src="${avatarUrl}" alt="$Name">`)

        avatarElement.innerHTML = `<img src="${avatarUrl}" alt="$Name">`;
    }

    setTimeout(() => {
        Toast.fire({
            icon: (response.status === 'ok') ? 'success' : 'error',
            title: response.message
        })
    }, SIMULATED_DELAY);
};


/**
 * 
 * Handle a form submission
 * 
 * @param {element} $formSection 
 * @param {object} data 
 * @param {string} method 
 */
const saveFormSubmission = ($formSection, url, data, method = 'POST') => {
    fetch(url, { method, body: JSON.stringify(data) })
        .then(response => response.json())
        .then(data => handleFormResponse(data))
        .finally(() => {
            setTimeout(() => {
                $formSection.classList.remove('busy')
                $formSection.querySelector('.js-save-form-section').setAttribute('disabled', 'disabled');
                if ($formSection.getAttribute('id') === undefined) {
                    window.location.hash = '#security';
                    window.location.reload();
                }
            }, SIMULATED_DELAY);
        });
};


/**
 * 
 * Get form data
 * 
 * @param {element} $formSection 
 * @returns {object} data
 */
const getFormData = ($formSection) => {
    let data = {};

    // Get all form inputs
    let $inputs = $formSection.querySelectorAll('input, select, textarea');
    $inputs.forEach($input => data[$input.name] = $input.value);

    // Get all checkboxes
    let $checkboxes = $formSection.querySelectorAll('input[type="checkbox"]');
    $checkboxes.forEach($checkbox => data[$checkbox.name] = $checkbox.checked);

    // Get all radios
    let $radios = $formSection.querySelectorAll('input[type="radio"]');
    $radios.forEach($radio => ($radio.checked) ? data[$radio.name] = $radio.value : null);

    return data;

};





let $saveFormSections = $$('.js-form-section');

// Save form submissions
$saveFormSections.forEach($formSection => {

    // Enable save button on change of selects, checkboxes, and radios
    let $selects = $formSection.querySelectorAll('select, input[type="checkbox"], input[type="radio"]');
    let $inputs = $formSection.querySelectorAll('input[type="text"],input[type="email"],input[type="password"], textarea');
    let $saveButton = $formSection.querySelector('.js-save-form-section');

    $selects.forEach($input => {
        $input.addEventListener('change', () => $saveButton.removeAttribute('disabled'));
    });

    $inputs.forEach($input => {
        $input.addEventListener('input', () => $saveButton.removeAttribute('disabled'));
    });
})

let $saveFormButtons = $$('.js-save-form-section');

// Save form submissions
$saveFormButtons.forEach($saveFormButton => {

    // Handle form submission
    $saveFormButton.addEventListener('click', (e) => {
        e.preventDefault();

        // Get the form section
        let $formSection = $saveFormButton.closest('.js-form-section');

        // Prevent multiple submissions with a busy state
        $formSection.classList.add('busy');

        // Save the form submission
        saveFormSubmission($formSection, $saveFormButton.dataset.apiUrl, getFormData($formSection));
    });

})

if ($saveFormButtons.length > 0) {

    // Get a reference to the file input element
    const avatar = document.querySelector('#uppy');

    let uppy = new Uppy({
        restrictions: {
            maxNumberOfFiles: 1,
            allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg']
        }
    }).use(Dashboard, {
        singleFileFullScreen: true,
        inline: true,
        proudlyDisplayPoweredByUppy: false,
        target: '#uppy',
        width: 360,
        height: 360,
        restrictions: {
            maxNumberOfFiles: 1,
            allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg']
        },
        showAddMoreButton: false,
    })
        .use(ImageEditor, {
            aspectRatio: 1,
            target: Dashboard,
            actions: {
                revert: true,
                rotate: false,
                granularRotate: false,
                flip: true,
                zoomIn: true,
                zoomOut: true,
                cropSquare: false,
                cropWidescreen: false,
                cropWidescreenVertical: false,
            },
            cropperOptions: {
                aspectRatio: 1,
                cropBoxMovable: false,
                cropBoxResizable: false,
                guides: false,
                center: false,
                autoCrop: true,
                autoCropArea: 1,
                movable: true,
                rotatable: false,
                dragMode: 'move',
                viewMode: 1,
            },
        })
        .use(ThumbnailGenerator, { thumbnailWidth: 300, thumbnailHeight: 300 });


    uppy.on('file-added', (file, preview) => {
        setTimeout(() => {
            if (!avatar.dataset.url)
                $('.uppy-Dashboard-Item-action--edit').click();
        }, 100);
        $saveButton.removeAttribute('disabled');
    });

    uppy.on('file-editor:start', (file) => {
        $saveButton.setAttribute('disabled', 'disabled');
    });


    uppy.on('file-editor:complete', (file) => {
        $saveButton.removeAttribute('disabled');
    });




    if (avatar.dataset.url) {
        // Function to preload an image into Uppy
        function preloadImage(fileUrl, fileName = 'avatar') {
            fetch(fileUrl)
                .then((response) => response.blob()) // Convert image to Blob
                .then((blob) => {
                    const file = new File([blob], fileName, { type: blob.type });

                    uppy.addFile({
                        name: fileName,
                        type: blob.type,
                        data: file, // File object
                        source: 'local',
                        isRemote: false,
                    });
                })
                .catch((error) => console.error('Error loading image:', error));
        }

        // Call this function with the URL of the image you want to preload
        preloadImage(avatar.dataset.url);

    }

    let $saveButton = document.querySelector('.js-save-avatar-button');

    // Handle form submission
    $saveButton.addEventListener('click', (e) => {
        e.preventDefault();

        // Get the form section
        let $formSection = $saveButton.closest('.js-form-section');

        // Prevent multiple submissions with a busy state
        $formSection.classList.add('busy');

        function getFileDataURL(fileId, callback) {
            const file = uppy.getFile(fileId);
            if (file) {
                const reader = new FileReader();
                reader.onload = function (event) {
                    const dataURL = event.target.result; // This is the Data URL
                    callback(dataURL); // Execute the callback with the Data URL
                };
                reader.readAsDataURL(file.data); // Read the file as Data URL
            } else {
                console.error('File not found!');
            }
        }

        // Usage with form submission
        const file = uppy.getFiles()[0]; // Get the first uploaded file
        if (file) {
            getFileDataURL(file.id, function (dataURL) {
                // Call saveFormSubmission once the Data URL is ready
                saveFormSubmission($formSection, $saveButton.dataset.apiUrl, { avatar: dataURL });
            });
        } else {
            console.error('No file selected');
            // Prevent multiple submissions with a busy state
            $formSection.classList.remove('busy');
            Toast.fire({
                icon: 'error',
                title: 'No file selected'
            })
        }
    });


    let $scrollToFormSection = $$('.js-scroll-to-form-section');

    $scrollToFormSection.forEach($scrollToFormSection => {
        $scrollToFormSection.addEventListener('click', (e) => {
            e.preventDefault();
            let target = $scrollToFormSection.getAttribute('href');
            let $formSection = document.querySelector(target.substring(target.indexOf('#')));
            $formSection.scrollIntoView({ behavior: 'smooth' });
        });
    });
    /*------------------------------------------------------------------
    In view elements
    ------------------------------------------------------------------*/

    // Define the options for our IntersectionObserver
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5

    };

    // Define the callback function for the IntersectionObserver
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $scrollToFormSection.forEach($scrollToFormSection => {
                    $scrollToFormSection.classList.remove('active');
                    if ($scrollToFormSection.getAttribute('href').includes(`#${entry.target.getAttribute('id')}`)) {
                        $scrollToFormSection.classList.add('active');
                    }
                });
            }

        });
    };

    // Create a new IntersectionObserver instance with the callback function and options
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each element with the 'js-inview' class
    $saveFormSections.forEach(element => observer.observe(element));


}



let deleteButton = $('.js-delete-your-account');

if (deleteButton) {
    deleteButton.addEventListener('click', (e) => {
        e.preventDefault();
        Swal.fire({
            title: 'Delete Account',
            text: 'Are you sure you want to delete your account?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete Account'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(deleteButton.dataset.apiUrl, { method: 'GET' })
                    .then(response => response.json())
                    .then(data => {
                        window.delete_key = data.data.key;

                        Swal.fire({
                            title: 'Last Step',
                            text: 'To confirm your account deletion, please click below.',
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: 'Cancel',
                            confirmButtonText: 'Delete Account'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                fetch(deleteButton.dataset.deleteUrl + window.delete_key, { method: 'GET' })
                                    .then(response => response.json())
                                    .then(data => {
                                        window.location = data.data.redirect;
                                    })
                            }
                        })
                    })
            }
        })
    });
}




const getHumanReadableUA = (uaString) => {
    const osMatch = uaString.match(/\(([^)]+)\)/);
    const os = osMatch ? osMatch[1].replace(/_/g, '.') : 'Unknown OS';

    const browserMatch = uaString.match(/(Chrome|Firefox|Safari|Edge|Opera)\/([\d.]+)/);
    const browser = browserMatch ? `${browserMatch[1]} ${browserMatch[2]}` : 'Unknown Browser';

    return `${browser} on ${os}`;
}



let $userAgents = $$('.js-user-agent');

$userAgents.forEach($userAgent => {
    let prettyString = getHumanReadableUA($userAgent.innerText);
    $userAgent.innerText = prettyString;
});

let $editBiometrics = $$('.js-edit-biometric-entry');
let $removeBiometrics = $$('.js-remove-biometric-entry');

$editBiometrics.forEach($editBiometric => {
    $editBiometric.addEventListener('click', (e) => {
        e.preventDefault();

        Swal.fire({
            title: "Add your own custom identifier",
            input: "text",
            inputPlaceholder: "Custom biometric name"
        }).then((result) => {
            if (result.value && result.isConfirmed) {
                fetch($editBiometric.dataset.apiUrl, {
                    method: 'POST',
                    body: JSON.stringify({ Label: result.value })
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        if (data.status === 'ok') {
                            Toast.fire({
                                icon: 'success',
                                title: data.message
                            })
                            let label = $editBiometric.closest('tr').querySelector('td:first-of-type');
                            label.innerText = result.value;

                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: data.message
                            })
                        }
                    })
            }
        });

    });
})

$removeBiometrics.forEach($removeBiometric => {
    $removeBiometric.addEventListener('click', (e) => {
        e.preventDefault();

        Swal.fire({
            title: "Are you sure?",
            text: "This will remove the biometric entry from your account.",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Remove'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch($removeBiometric.dataset.apiUrl, {
                    method: 'POST',
                    body: JSON.stringify({ Label: $removeBiometric.dataset.label })
                })
                    .then(response => response.json())
                    .then(data => {
                        window.location.reload();
                    })
                    .finally(() => {
                        window.location.reload();
                    })
            }
        });

    });
})


